import React, { useState, useRef } from 'react';
import { ColorPickerModal } from './ColorPickerModal';
import { GREY } from '~/Constants/Colors.constants';
import { ColorButton, Button } from '~/UIKit';
import { ChevronRight } from '@mui/icons-material';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  button: {
    color: GREY,
    fontWeight: 'normal',
    marginLeft: 'auto',
    paddingRight: 0,
    // Offsets Chevron padding
    marginRight: '-8px',
  },
}));

export const ColorPicker = ({
  updateColor,
  color,
  disabled,
}: {
  updateColor: (color: string) => void;
  color: string;
  disabled?: boolean;
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const { classes } = useStyles();

  return (
    <>
      <Button
        ref={buttonRef}
        type="button"
        disabled={disabled}
        onClick={() => setOpen(true)}
        className={classes.button}
        data-testid="colorpicker-button"
      >
        <ColorButton
          color={color}
          onClick={() => setOpen(true)}
          dontUseButtonElement
          disabled={disabled}
          isButtonSelected={false}
          variation="secondary"
        />
        <ChevronRight />
      </Button>
      <ColorPickerModal
        updateColor={updateColor}
        currentColor={color}
        open={open}
        onClose={() => setOpen(false)}
        data-testid="colourselectioninput-modal"
        anchorEl={buttonRef.current}
      />
    </>
  );
};
